import type { OrderKpiMetrics } from '@klareospace/pharos-lib-types';
import { KPI_KEYS } from '@klareospace/pharos-lib-types';

import { toOrderKpiMetrics } from './order-kpi-metrics.utils';
import { useKpiMtdQuery } from './use-kpi-mtd-query';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UseOrderKpisMonthParams {
  /** The "This month" tab must be active for this query to run — no request fires on page load. */
  enabled: boolean;
}

export interface UseOrderKpisMonthResult {
  /** When the KPI was last computed — absent until the first successful pipeline run. */
  computedAt: Date | undefined;
  isError: boolean;
  isLoading: boolean;
  metrics: OrderKpiMetrics | undefined;
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

/** Fetches the month-to-date `order-kpis` KPI for the current scope, gated on `feat-dashboard` + `kpis:read` + `enabled`. */
export function useOrderKpisMonth({ enabled }: UseOrderKpisMonthParams): UseOrderKpisMonthResult {
  const { data, isError, isLoading } = useKpiMtdQuery({
    enabled,
    fetchKpi: (api, params) => api.getOrderKpisMtd(params),
    key: KPI_KEYS.ORDER_KPIS,
  });

  return {
    computedAt: data?.computedAt,
    isError,
    isLoading,
    metrics: toOrderKpiMetrics(data?.metrics),
  };
}
